module.exports = __webpack_public_path__ + "img/ground-ground-day.7f413daf.png";